import { type RefObject, useEffect, useState } from "react";

/**
 * Element ko'rinish oynasiga BIR MARTA kirganini bildiradi (keyin `true`
 * bo'lib qoladi — karta scroll'da qayta so'rov yubormasin).
 *
 * ⚠️ `IntersectionObserver` yo'q muhitda (eski brauzer) darhol `true`.
 * ⚠️ happy-dom da u BOR, lekin hech qachon chaqirilmaydigan stub —
 * testlar o'z soxta kuzatuvchisini o'rnatadi (`ReportsPage.test.tsx`),
 * aks holda har karta so'rovi `enabled: false` bo'lib, bo'sh render
 * yashil test berardi.
 */
export function useInView(ref: RefObject<Element | null>, rootMargin = "200px"): boolean {
	const [inView, setInView] = useState(() => typeof IntersectionObserver === "undefined");

	useEffect(() => {
		const element = ref.current;

		if (inView || !element || typeof IntersectionObserver === "undefined") {
			return;
		}

		const observer = new IntersectionObserver(
			(entries) => {
				if (entries.some((entry) => entry.isIntersecting)) {
					setInView(true);
					observer.disconnect();
				}
			},
			{ rootMargin }
		);

		observer.observe(element);

		return () => observer.disconnect();
	}, [ref, inView, rootMargin]);

	return inView;
}
